import { NavLink } from "react-router-dom";
import { LayoutDashboard, Database, Sun, Moon, Users, Presentation, LogOut, MessageSquareText } from "lucide-react";
import { useAuth } from "../lib/auth";
import { useTheme } from "../hooks/useTheme";

const Item = ({ to, icon: Icon, label, testId }) => (
  <NavLink to={to} end data-testid={testId}
    className={({ isActive }) => `inline-flex items-center gap-2 text-sm px-3 py-2 rounded-md transition-colors duration-150 ${isActive ? "bg-slate-700 text-white" : "text-slate-400 hover:text-slate-200"}`}>
    <Icon className="h-4 w-4" /><span className="hidden sm:inline">{label}</span>
  </NavLink>
);

export const AppShell = ({ children }) => {
  const [theme, toggle] = useTheme();
  const { user, isManager, logout } = useAuth();
  return (
  <div>
    <header className="sticky top-0 z-30 bg-[#111827]/90 backdrop-blur-md border-b border-slate-800">
      <div className="max-w-[1500px] mx-auto px-4 sm:px-8 h-16 flex items-center gap-3">
        <img src={theme === "dark" ? "/brand/ep-group-white.png" : "/brand/ep-group-dark.png"} alt="EP Group" className="h-8 w-auto" data-testid="app-logo" />
        <span className="hidden md:inline h-6 w-px bg-slate-700 mx-1" />
        <span className="hidden md:inline font-display font-bold text-slate-100 tracking-tight mr-4 whitespace-nowrap" data-testid="app-brand">Warehouse Activity Monitor</span>
        <nav className="flex gap-1 ml-auto">
          <Item to="/summary" icon={Presentation} label="Exec summary" testId="nav-summary" />
          <Item to="/" icon={LayoutDashboard} label="Dashboard" testId="nav-dashboard" />
          <Item to="/pickers" icon={Users} label="Pickers" testId="nav-pickers" />
          <Item to="/notes" icon={MessageSquareText} label="Notes" testId="nav-notes" />
          {isManager && <Item to="/manage" icon={Database} label="Manage data" testId="nav-manage" />}
        </nav>
        <button data-testid="theme-toggle" onClick={toggle} title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"} className="ml-1 h-9 w-9 inline-flex items-center justify-center rounded-md border border-slate-700 text-slate-300 hover:bg-slate-800 transition-colors">
          {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </button>
        <div className="hidden lg:flex flex-col items-end leading-tight ml-2" data-testid="current-user">
          <span className="text-xs text-slate-200">{user?.email}</span>
          <span className={`text-[10px] font-mono uppercase tracking-wider ${isManager ? "text-ep-soft" : "text-slate-500"}`} data-testid="current-user-role">{user?.role}</span>
        </div>
        <button data-testid="logout-button" onClick={logout} title="Sign out" className="h-9 w-9 inline-flex items-center justify-center rounded-md border border-slate-700 text-slate-300 hover:bg-slate-800 transition-colors"><LogOut className="h-4 w-4" /></button>
      </div>
    </header>
    {children}
  </div>
  );
};
